import React from "react";
import { icon } from "../../../config/constants";
import "./SubsectionHeader.scss";

const SubsectionHeader = ({ subsection, subsectionIndex, isExpanded = false, isSelected = false, onSelect, onToggleExpanded, onDelete }) => {
  const handleExpandClick = (e) => {
    e.stopPropagation();
    onToggleExpanded(subsection.id);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete(subsection.id);
  };

  const handleHeaderClick = (e) => {
    // Don't trigger selection if clicking on buttons
    if (e.target.closest("button")) {
      return;
    }
    onSelect?.(subsection);
  };

  const displayName = subsection.title || `Subsection ${subsectionIndex}`;

  return (
    <div
      className={`subsection-header d-flex justify-content-between align-items-center ${isSelected ? "selected" : ""}`}
      onClick={handleHeaderClick}
      style={{ cursor: "pointer" }}>
      {/* Left side: Name */}
      <div className='subsection-header-left d-flex align-items-center'>
        <h6 className='subsection-name mb-0 me-2'>{displayName}</h6>
      </div>

      {/* Right side: Expand and Delete */}
      <div className='subsection-header-right d-flex align-items-center'>
        <button
          className={`expand-btn bg-transparent border-0 me-2 ${isExpanded ? "expanded" : ""}`}
          onClick={handleExpandClick}
          title={isExpanded ? "Collapse subsection" : "Expand subsection"}>
          {icon.ARROW_FORWARD_IOS}
        </button>
        <button
          id={`subsection-delete-btn-${subsection.id}`}
          className='subsection-delete-btn bg-transparent border-0'
          onClick={handleDeleteClick}
          title='Delete Subsection'>
          {icon.DELETE_ICON}
        </button>
      </div>
    </div>
  );
};

export default SubsectionHeader;
